<ng-template [ngIf]="status">
    <span [class]="status | clienteAnaliseFinanceiraStatusBadge">
        {{status | clienteAnaliseFinanceiraStatus}}
    </span>
</ng-template>